import React, { useEffect, useState } from "react";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import Select from "react-select";
import FileUploader from "./Component/FileUploader";
import moment from "moment";

const EmployeeAdminAddForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Raise Admin Ticket"));
  }, []);

  const initialFormData = {
    CategoryId: null,
    SubCategory: null,
    File: "",
    Type: null,
    Details: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [categoryOption, setCategoryOption] = useState([]);
  const [requisitionOption, setRequisitionOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    fetchGetEmployeeAdminList();
  }, []);

  const fetchGetEmployeeAdminList = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}requisition/admin/add`
      );

      if (response?.status === 200) {
        const cleanedData = response?.data?.data || [];
        console.log("cleanedData", cleanedData);

        const reqType = cleanedData?.requisitionTypes?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setRequisitionOption(reqType);
        const catList = cleanedData?.categories?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setCategoryOption(catList);
        setPageLoading(false);
      } else {
        console.error(
          "Failed to fetch Employee Admin List. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Employee Admin List:", error);
    } finally {
      setLoading(false); // Always stop loading, even if there's an error
    }
  };

  const [subCategoryOption, setSubCategoryOption] = useState([]);

  useEffect(() => {
    if (
      formData.CategoryId !== undefined &&
      formData.CategoryId !== null &&
      formData.CategoryId !== ""
    ) {
      setSubCategoryOption([]); // Clear brand options while fetching new data

      setFormData((prevData) => ({
        ...prevData,
        SubCategory: null,
      }));

      fetchGetSubCategoryDetails(formData.CategoryId);
    }
  }, [formData.CategoryId]);
  const fetchGetSubCategoryDetails = async (id) => {
    try {
      const queryParams = new URLSearchParams({
        Category: id,
      });
      const response = await GetServiceCaller(
        `${API_URL}requisition/get-subcategories?${queryParams.toString()}`
      );
      if (response.status === 200) {
        const fetchData = response?.data?.data;

        const subCategoryList = fetchData?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setSubCategoryOption(subCategoryList);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch model masters. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching brand details:", error);
    }
  };

  const schema = Yup.object().shape({
    CategoryId: Yup.number()
      .typeError("Category is required")
      .required("Category is required"),
    SubCategory: Yup.number()
      .typeError("Sub Category  is required")
      .required("Sub Category is required"),
    Type: Yup.number()
      .typeError("Type  is required")
      .required("Type is required"),
    Details: Yup.string().required("Details is required"),
    File: Yup.string(),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field
      await schema.validateAt(fieldName, updatedData);

      // Clear the error for the specific field if validation is successful
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        // Show error using toast for specific fields if needed
        if (fieldName.startsWith("lines")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Validation error structure is not as expected:", err);
      }
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    // Update form data only for fields in the schema
    if (schema.fields[name]) {
      setFormData((prevData) => {
        const updatedData = { ...prevData, [name]: value };
        validateField(name, updatedData);
        return updatedData;
      });
    }
  };

  const handleSelect = async (selectedOption, name) => {
    // Update formData with the selected value for the SkillID
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData);
      return updatedData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate formData using schema
      await schema.validate(formData, { abortEarly: false });
      setErrors({}); // Clear previous errors

      // Call the API
      const response = await PostFormServiceCaller(
        `${API_URL}requisition/admin`,
        {
          ...formData,
          categoryName: categoryOption?.find(
            (o) => o.value === Number(formData?.CategoryId)
          )?.label,
          SubCategoryName: subCategoryOption?.find(
            (o) => o.value === Number(formData?.SubCategory)
          )?.label,
          mailDescription: formData?.Details,
        },
        "post"
      );

      if (response.status === 201) {
        toast.success("Data submitted successfully");
        // Redirect after a successful submission
        setTimeout(() => {
          navigate(`/admin/tickets`);
        }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };
  const [resumeFile, setResumeFile] = useState({});
  const [fileName, setFileName] = useState({});

  const handleFile = (file) => {
    if (file) {
      // Clear previous error messages
      setErrors((prevErrors) => ({
        ...prevErrors,
        File: "",
      }));

      // Update the state with file details
      const { name } = file;
      setFileName(name);
      setFormData((prevState) => ({
        ...prevState,
        File: file,
      }));
      setResumeFile(file);
    } else {
      // Set an error message for invalid files
      setErrors((prevErrors) => ({
        ...prevErrors,
        File: "File size should not exceed 10MB and must be a supported format (PDF, Word, Excel, Image).",
      }));
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container m-2 m-sm-0">
          <form
            id="formOne"
            className="rounded mt-2 bg-white p-3"
            onSubmit={handleSubmit}
          >
              <div class="card-body">
                <div className="row">
                  <div className="col-md-3">
                    <label class="form-label">
                      Date<span className="text-danger">*</span>
                    </label>
                    <CustomDatePicker
                      // handleChange={(e) => handleReqDate(e)}
                      handleChange={(e) => handleChange(e)}
                      value={moment(new Date()).format("DD-MMM-YYYY")}
                      readOnly={true}
                      name="Date"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                    />
                  </div>
                  <div className="col-md-3">
                    <label class="form-label">
                      Category<span className="text-danger">*</span>
                    </label>
                    <Select
                      name="CategoryId"
                      onChange={(selectedOption, action) =>
                        handleSelect(selectedOption, action.name)
                      }
                      value={categoryOption?.find(
                        (o) => o.value === formData?.CategoryId
                      )}
                      // className={errors.CategoryId ? "react-select-error" : ""}
                      options={[
                        { value: null, label: "Select" },
                        ...categoryOption,
                      ]}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: errors.CategoryId
                            ? "#dc3545"
                            : base.borderColor,
                        }),
                      }}
                    />{" "}
                    {errors.CategoryId && (
                      <div className="text-danger">{errors.CategoryId}</div>
                    )}
                  </div>
                  <div className="col-md-3">
                    <label class="form-label">
                      Sub Category<span className="text-danger">*</span>
                    </label>
                    <Select
                      name="SubCategory"
                      onChange={(selectedOption, action) =>
                        handleSelect(selectedOption, action.name)
                      }
                      value={subCategoryOption?.find(
                        (o) => o.value === formData?.SubCategory
                      )}
                      // className={` ${errors.SubCategory ? "is-invalid" : ""}`}
                      options={[
                        { value: null, label: "Select" },
                        ...subCategoryOption,
                      ]}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: errors.SubCategory
                            ? "#dc3545"
                            : base.borderColor,
                        }),
                      }}
                    />
                    {errors.SubCategory && (
                      <div className="text-danger">{errors.SubCategory}</div>
                    )}
                  </div>
                  <div className="col-md-3">
                    <label class="form-label">
                      Type<span className="text-danger">*</span>
                    </label>
                    <Select
                      name="Type"
                      onChange={(selectedOption, action) =>
                        handleSelect(selectedOption, action.name)
                      }
                      value={requisitionOption?.find(
                        (o) => o.value === formData?.Type
                      )}
                      // className={` ${errors.Type ? "is-invalid" : ""}`}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: errors.Type
                            ? "#dc3545"
                            : base.borderColor,
                        }),
                      }}
                      options={[
                        { value: null, label: "Select" },
                        ...requisitionOption,
                      ]}
                    />
                    {errors.Type && (
                      <div className="text-danger">{errors.Type}</div>
                    )}
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-md-3">
                    <label class="form-label">
                      Details <span className="text-danger">*</span>
                    </label>
                    <textarea
                      name="Details"
                      onChange={(e) => handleChange(e)}
                      className={`form-control ${
                        errors.Details ? "is-invalid" : ""
                      }`}
                    />
                    {errors.Details && (
                      <div className="invalid-feedback">{errors.Details}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      Allowed types: jpg, jpeg, png, doc, docx, pdf, xls, xlsx
                      <span className="text-danger me-2">*</span>
                    </label>
                    <div className="d-flex">
                      <div>
                        <div>
                          <FileUploader
                            handleFile={handleFile}
                            buttonLabel={"Upload File"}
                          />
                        </div>
                        <span>
                          {formData?.File && (
                            <a className="m-2">{formData?.File?.name}</a>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="d-flex justify-content-end">
                    <div className="d-flex">
                      <div>
                        <button
                          type="button"
                          className="cancel-btn me-2"
                          onClick={() => navigate(`/admin/tickets`)}
                        >
                          Cancel
                        </button>
                      </div>
                      <div>
                        <button
                          disabled={loading ? true : false}
                          type="submit"
                          className="custom-btn"
                        >
                          {loading ? (
                            <FaSpinner class="sm-spinner" />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </form>
        </div>
      </>
    );
  }
};

export default EmployeeAdminAddForm;
